export default __webpack_public_path__ + "images/DY.d91a57f.png";